import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import UserStorageManager from "./UserProject/UserStorageManager";
import {Auth, Storage} from "aws-amplify";
import {MUI_STYLES} from "./constants";
import Unity, {UnityContent} from "react-unity-webgl";
import Logo from "./AkularSVGBanerLogo";
import CloseIcon from "@material-ui/icons/Close";

const styles = MUI_STYLES;


class ModelViewer extends React.Component {
  
  constructor(props) {
    super(props);
    this.modelName = new URLSearchParams(window.location.search).get('modelname');
    this.projectName = new URLSearchParams(window.location.search).get('projectname');
    
    this.state = { expanded: "" };

    this.unityContent = new UnityContent(
      "./UnityBuild/Build/build2.json",
      "./UnityBuild/Build/UnityLoader.js"
    );

    this.unityContent.on("ViewerLoaded", score => {

      this.loadModel();

    });

    this.unityContent.on("OpenHelpURL", () => {

      window.open("https://app.akular.com/help", "_blank")

    });

    this.unityContent.on("OpenHomeURL", () => {

      window.open("https://akular.com", "_blank")

    });

  }

  componentDidMount() {
  }

  handleExpandChange = projectData => (value, expanded) => {
    if (this.state.expanded === projectData.projectKey) {
      if (projectData.projectKey === "addProject") {
        Object.assign(projectData, {
          lat: 0,
          lng: 0,
          rot: 0,
          projectName: null
        });
      } else {
        Object.assign(projectData, this.state.db.projects[projectData.index]);
      }
    }
    this.setState({
      expanded: expanded ? projectData.projectKey : false
    });
  };

  loadModel = async () => {
    const { awsStorageConfig } = this.props;
    let currentUserInfo = await Auth.currentUserInfo();
    this.userMan = new UserStorageManager(Storage, currentUserInfo, awsStorageConfig);
    let modelLink = await this.userMan.loadModel(this.modelName);

	  this.unityContent.send('AppManager', 'LoadAssetBundleFromURL', modelLink);
  };

   

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;


//jsx  wrapping  actual model viewer module
    return (
        <div className={classes.root}>
          <Unity unityContent={this.unityContent}/>

          <a href="#"  style={{color:"black"}}> <CloseIcon style={{color:"black"}} onClick={() => {
            window.close();
          }} style={{zIndex: 100, position: "absolute", right: 0, top: 0}}/></a>
        </div>
    );
  }
}

ModelViewer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ModelViewer);
